module.exports = __webpack_public_path__ + "img/red-fire.30f5c6c0.svg";